import { useCallback, useEffect, useState } from 'react';

const KEY = 'rj.nav.collapsed';

export function useNavGroups(activePath: string) {
  const [collapsed, setCollapsed] = useState<Record<string, boolean>>(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) ?? '{}');
    } catch {
      return {};
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify(collapsed));
    } catch {
      /* ignore quota/private-mode errors */
    }
  }, [collapsed]);

  const toggle = useCallback((group: string) => {
    setCollapsed((prev) => ({ ...prev, [group]: !prev[group] }));
  }, []);

  // A group with the active route in it is always open, regardless of saved state.
  const isGroupActive = useCallback(
    (group: string, groupTo: string[]) =>
      groupTo.some((to) => to === activePath),
    [activePath],
  );

  return { collapsed, toggle, isGroupActive };
}
